import React from 'react'
import ViewBanner from './ViewBanner';
import ViewBannerBreadCrumb from './ViewBannerBreadCrumb';

function ViewBannerPage() {
    return ( 
        <div className = "container-fluid">
             <ViewBannerBreadCrumb />
            <ViewBanner />
        </div>
     );
}

export default ViewBannerPage;